import React from 'react';
import { UiButton } from './Button.style';

export const Button = ({ type, onClick, children }) => <UiButton type={type} onClick={onClick}>{children}</UiButton>;
